function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGames = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 0.335,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.949,11.535C8.986,11.535 4.149,16.373 4.149,22.335C4.149,28.298 8.986,33.135 14.949,33.135L29.349,33.135C35.311,33.135 40.149,28.298 40.149,22.335C40.149,16.373 35.311,11.535 29.349,11.535L14.949,11.535ZM32.049,21.885C30.806,21.885 29.799,20.878 29.799,19.635C29.799,18.392 30.806,17.385 32.049,17.385C33.292,17.385 34.299,18.392 34.299,19.635C34.299,20.878 33.292,21.885 32.049,21.885ZM30.699,25.035C30.699,26.278 29.692,27.285 28.449,27.285C27.206,27.285 26.199,26.278 26.199,25.035C26.199,23.792 27.206,22.785 28.449,22.785C29.692,22.785 30.699,23.792 30.699,25.035ZM13.599,19.185C13.599,18.437 14.201,17.835 14.949,17.835C15.697,17.835 16.299,18.437 16.299,19.185L16.299,20.985L18.099,20.985C18.847,20.985 19.449,21.587 19.449,22.335C19.449,23.083 18.847,23.685 18.099,23.685L16.299,23.685L16.299,25.485C16.299,26.233 15.697,26.835 14.949,26.835C14.201,26.835 13.599,26.233 13.599,25.485L13.599,23.685L11.799,23.685C11.051,23.685 10.449,23.083 10.449,22.335C10.449,21.587 11.051,20.985 11.799,20.985L13.599,20.985L13.599,19.185Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGames);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/games.a2153853a9334f9fcf53d4ac28113bce.svg";